import styled from 'styled-components';
import { tablet768, desktop1024, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder } from 'styles/themeUtils';

const SectionParagraphContainer = styled.div`
  ${tablet768`
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 50%;
  `}

  ${desktop1024`
    ${paddingBuilder.right(0.5)}
  `}

  ${desktop1440`
    ${paddingBuilder.right(0)}
  `}
`;

SectionParagraphContainer.displayName = 'SectionParagraphContainer';

export default SectionParagraphContainer;
